import styled from '@emotion/styled';
import { tokens } from '../../../public/tokens';

const { colors, globals, effects } = tokens;

/**
 * Flexible, scrollable container that wraps content
 * and occupies the viewport height minus the header (48px).
 */
export const ContentWrapper = styled.div({
    display: 'flex',
    flexWrap: 'wrap',
    height: 'calc(100vh - 48px)',
    maxHeight: 'calc(100vh - 48px)',
    overflowY: 'auto',
    background: colors.surfaces['page-background'],
});

/**
 * Standard bordered container for page content.
 * @param {string} [background] - Overrides the default container background.
 */
export const ContainerWrapper = styled.div(({ background }) => ({
    background: background ?? colors.surfaces['container-background'],
    borderRadius: globals['border-radius'],
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: colors.surfaces['border-divider'],
    padding: globals['spacing-lg'],
    boxShadow: effects.effects.shadow.default,
}));

/**
 * `ContainerWrapper` extended with flex-item and column-layout behavior for use
 * as a panel within a flex row of sibling sections.
 * @param {number} [flex] - flex-grow/shrink/basis shorthand for sizing within a flex row.
 * @param {boolean} [$plain] - Strips border, background, and padding when true.
 */
export const SectionContainerWrapper = styled(ContainerWrapper)(({ flex, $plain }) => ({
    flex,
    display: 'flex',
    flexDirection: 'column',
    padding: $plain ? 0 : '12px',
    boxShadow: 'none',

    ...($plain && {
        borderColor: 'transparent',
        background: 'transparent',
    }),
}));
